import { render, staticRenderFns } from "./detalleneumatico.vue?vue&type=template&id=c1e7aa24"
import script from "./detalleneumatico.vue?vue&type=script&lang=js"
export * from "./detalleneumatico.vue?vue&type=script&lang=js"
import style0 from "./detalleneumatico.vue?vue&type=style&index=0&id=c1e7aa24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports